export default "__VITE_ASSET__e41908b9__"